import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/share.scss";
import { motion } from "framer-motion"
import axios from "axios";
import { backend } from '../../components/apipath';
import Sharearea from "../home/components/sharearea";

function Share() {
    

    const [groupedData, setGroupedData] = useState([]);
    const [sharesEssence, setSharesEssence] = useState([]);
    const [selectedCard, setSelectedCard] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${backend}share/sharesEssence`);
                setSharesEssence(response.data);
                // console.log(response.data);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchData();

    }, []);


    

    
    const [currentPage, setCurrentPage] = useState(1);
    const cardsPerPage = 8;
    const totalCards = Object.values(groupedData).flat().length;
    const totalPages = Math.ceil(totalCards / cardsPerPage);
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentCards = Array.isArray(groupedData) ? groupedData.slice(startIndex, endIndex) : [];

    const getPageNumbersToShow = () => {
        const maxPageNumbersToShow = 10;
        const middlePage = currentPage;
        const halfMaxPageNumbersToShow = Math.floor(maxPageNumbersToShow / 2);

        let startPage = middlePage - halfMaxPageNumbersToShow;
        let endPage = middlePage + halfMaxPageNumbersToShow;

        if (startPage <= 0) {
            startPage = 1;
            endPage = Math.min(totalPages, maxPageNumbersToShow);
        }

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, totalPages - maxPageNumbersToShow + 1);
        }

        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    };
    //more按鈕資料
    const handleMoreClick = (item) => {
        setSelectedCard(item);
    };


    return (
        <>
            {/* banner */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./shareImg/share.jpg" alt=""/>
                </motion.div>
                {/* <div className="bannerttitle dis">
                    SHARE
                </div> */}
            </div>
            {/* share */}
            <div className="container">
                {/* <div className="beckertitlename text-center mb100 mt100">精選成功案例</div>
                <div className="tabcontent mb100">
                    <div className="container">
                        <div className="tabcontent">
                            <div className="tab-content row featured" id="myTab1Content">
                                {sharesEssence.map((item, index) => (
                                    <div className="card sharecard col-3 m-2" key={`${index}-${item.art_id}`}>
                                        <div className="card-body">
                                            <div className="mb-4">
                                                <img src={item.cover_1} alt={item.title} />
                                            </div>
                                            <h5 className="card-title sharetitle">{item.title}</h5>
                                            <div ></div>
                                            <p className="card-text sharecontent" dangerouslySetInnerHTML={{ __html: item.intro }}></p>
                                            <Link to={`/share/detail/${item.art_id}`} className="btn btn-primary " onClick={() => handleMoreClick(item)}>more</Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="beckertitlename text-center mb100">歷年心得分享</div>
                {/* share */}
                <div className="container">
                        <Sharearea/>
                </div>
            </div>
        </>
    );
}
export default Share;